export default function ProgressIcon({ currentIndex }) {
  return <img src={`/svg/progress-${currentIndex}.svg`} />
}
